import { useWizard } from "../../../store/hooks/useWizard";
import CustomContainer from "../../shared/CustomContainer";
import Topbar from "../../Topbar/Topbar";
import WizardHeader from "../Header/WizardHeader";
import WizardNavigation from "../Navigation/WizardNavigation";
import "./WizardContainer.scss";

const WizardContainer = ({ children }) => {
  const wizard = useWizard();

  return (
    <>
      <div className="content">
        <Topbar />
        <WizardHeader wizard={wizard} />
        <div className="spacer"></div>
        <CustomContainer>
          <div>{children}</div>
        </CustomContainer>
      </div>
      <WizardNavigation wizard={wizard} />
    </>
  );
};

export default WizardContainer;
